const API_VERSION_HEADER = 'x-app-version';
const API_VERSION_STORAGE_KEY = 'api_version';

// Callback for when API version changes
let onApiVersionChange: (() => void) | null = null;

export function setOnApiVersionChange(callback: () => void) {
  onApiVersionChange = callback;
}

/**
 * Check API response headers for version changes.
 * Call this from Axios response interceptors.
 */
export function checkApiVersionHeader(headers: Record<string, string>) {
  const serverVersion = headers[API_VERSION_HEADER];
  if (serverVersion) {
    const storedVersion = localStorage.getItem(API_VERSION_STORAGE_KEY);
    if (storedVersion === null) {
      // First request - store the version
      localStorage.setItem(API_VERSION_STORAGE_KEY, serverVersion);
    } else if (storedVersion !== serverVersion) {
      // Version changed - trigger update notification
      if (onApiVersionChange) {
        onApiVersionChange();
      }
    }
  }
}
